export function safeParse (obj: string, onerror?: Function): any {
    try {
        return JSON.parse(obj);
    } catch (error) {
        if (onerror) {
            onerror(error);
        }
        return null;
    }
}

export function jsonCopy<T> (obj: T): T {
    return JSON.parse(JSON.stringify(obj));
}
